import { createTheme } from '@material-ui/core/styles';

// Paleta da marca (a mesma usada na Home em containers/Home/styles.js).
export const CORES = {
    verde: '#4B8B33',
    verdeEscuro: '#2F6420',
    verdeClaro: '#EAF3E5',
    texto: '#1B2418',
    textoSuave: '#56604F',
    borda: '#E1E5DE',
    fundo: '#F4F6F3',
    erro: '#A63A1A',
    alerta: '#9A6100',
    info: '#1E3F8A',
};

// Tema global do CRM. Antes cada tela definia suas cores (azul padrão do MUI no
// Login e no Formulário de Lead, botões cinza com texto verde nas listagens).
const tema = createTheme({
    palette: {
        primary: { main: CORES.verde, dark: CORES.verdeEscuro, light: CORES.verdeClaro, contrastText: '#fff' },
        // "secondary" era o rosa padrão do MUI e aparecia nos botões "Não" dos diálogos.
        secondary: { main: CORES.verdeEscuro, contrastText: '#fff' },
        error: { main: CORES.erro },
        warning: { main: CORES.alerta },
        info: { main: CORES.info },
        text: { primary: CORES.texto, secondary: CORES.textoSuave },
        divider: CORES.borda,
        background: { default: CORES.fundo, paper: '#fff' },
    },
    shape: { borderRadius: 8 },
    typography: {
        h1: { fontSize: 26, fontWeight: 700 },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    props: {
        MuiButton: { disableElevation: true },
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                h1: { fontSize: 26, fontWeight: 700, color: CORES.texto, margin: '8px 0 20px' },
            },
        },
        MuiTableCell: {
            head: { fontWeight: 600 },
        },
    },
});

export default tema;
